// Words that may not appear anywhere in a username (case insensitive).
// Add new entries here to block additional words - no other code changes needed.
export const FORBIDDEN_USERNAME_WORDS = ["tovek", "avslut", "admin"];
